import React, { Children } from "react";
import { BrowserRouter, Routes } from "react-router-dom";

const RouterProvider = ({ children }) => {
  return <BrowserRouter>{children}</BrowserRouter>;
};

export default RouterProvider;
